import React from 'react';
import {
	BaasicInput,
	BaasicSelect,
	Loader,
	BaasicCheckbox,
	BaasicHeader,
	BaasicConfirmModal,
	BaasicButton,
	BaasicModal,
	BaasicDropdown,
	SliderCheckBox,
} from 'core/components';
import { defaultTemplate } from 'core/hoc';
import {
	channelType,
	getAmazonOAuthUrl,
	carrierTypes as carrierTypesConstants,
	sellerCloudChannels,
} from 'common/constants';
import { observer } from 'mobx-react';
import { ButtonAndLink } from 'common/utils';
import { WarehouseCodes, CustomLabel } from 'modules/channel/pages';
import UpdateInventoryLog from 'modules/product/pages/UpdateInventoryLog';
import _ from 'lodash';
import { RestockDate } from 'modules/restock-date/pages';
import ReactTooltip from 'react-tooltip';

const ChannelEditTemplate = ({
	t,
	channelEditViewStore,
	channelEditViewStore: {
		form,
		loading,
		rootStore,
		onCheck,
		isEdit,
		openEditRestockDateModal,
		openEditChannelWarehouseCodesModal,
		openUpdateInventoryLogModal,
		validateCredentials,
		scheduledRestockDate,
		openCustomLabelModal,
	},
}) => {
	if (loading) return <Loader />;
	const pageTitle = !isEdit ? 'CREATECHANNEL' : 'EDITCHANNEL';

	return (
		<section>
			<BaasicHeader title={pageTitle} rootStore={rootStore}>
				{scheduledRestockDate && (
					<i
						data-tip={t('RESTOCKDATE.SCHEDULEDRESTOCKDATENOTE', { scheduledDate: scheduledRestockDate })}
						className="spc--right--sml far fa-clock type--color--success--light type--med"
					/>
				)}
				<ReactTooltip />
				{/* Restock Date */}
				{isEdit && form.$('channelType').value != '' && form.$('channelType').value.label === channelType.amazon && (
					<BaasicButton
						className="btn btn--med btn--primary btn--primary--negative"
						icon="icon icon--xmed icon--inventory-update spc--right--sml"
						onClick={() => {
							openEditRestockDateModal();
						}}
						label="RESTOCKDATE.TITLE"
					/>
				)}
				{/* Update Inventory */}
				{isEdit && form.$('channelType').value != '' && form.$('channelType').value.label !== channelType.manualOrders && (
					<BaasicButton
						className="btn btn--med btn--primary btn--primary--negative spc--left--tny"
						icon="icon icon--xmed icon--inventory-update spc--right--sml"
						onClick={() => {
							openUpdateInventoryLogModal();
						}}
						label="UPDATEINVENTORYLOG.TITLE"
					/>
				)}
				{/* Warehouse Codes */}
				<BaasicButton
					className="btn btn--med btn--primary btn--primary--negative spc--left--tny"
					icon="icon icon--xmed icon--warehouse-code--white spc--right--sml"
					onClick={() => {
						openEditChannelWarehouseCodesModal();
					}}
					label="WAREHOUSECODES.EDIT"
				/>
				{/* Test Connection */}
				{form.$('channelType').value.label !== channelType.manualOrders && (
					<BaasicButton
						className="btn btn--med btn--primary btn--primary--negative spc--left--tny"
						icon="icon icon--xmed icon--test-connection--white spc--right--sml"
						onClick={() => {
							validateCredentials();
						}}
						label="CHANNEL.TESTCONNECTION"
					/>
				)}
				{
					<BaasicButton
						className="btn btn--med btn--primary btn--primary--negative spc--left--tny"
						icon="icon icon--xmed icon--custom-label--white spc--right--sml"
						onClick={() => {
							openCustomLabelModal();
						}}
						label="CHANNEL.CUSTOMIZELABEL"
					/>
				}
			</BaasicHeader>
			<form className="container container--lrg container--footer" onSubmit={form.onSubmit}>
				<div className="container__group__wrapper">
					<GeneralChannelSettings viewStore={channelEditViewStore} t={t} />
					{form.$('channelType').value != '' && form.$('channelType').value.label === channelType.amazonVendor && (
						<AmazonVendorChannelSettings viewStore={channelEditViewStore} t={t} />
					)}
					{form.$('channelType').value != '' && form.$('channelType').value.label === channelType.amazon && (
						<AmazonChannelSettings viewStore={channelEditViewStore} t={t} />
					)}
					{form.$('channelType').value != '' && form.$('channelType').value.label === channelType.walmart && (
						<WalmartChannelSettings viewStore={channelEditViewStore} />
					)}
					{form.$('channelType').value != '' && form.$('channelType').value.label === channelType.wooCommerce && (
						<WooCommerceChannelSettings viewStore={channelEditViewStore} />
					)}
					{form.$('channelType').value != '' && form.$('channelType').value.label === channelType.costco && (
						<CostcoChannelSettings viewStore={channelEditViewStore} />
					)}
					{form.$('channelType').value != '' && form.$('channelType').value.label === channelType.logicBroker && (
						<LogicbrokerChannelSettings viewStore={channelEditViewStore} />
					)}
					{form.$('channelType').value != '' && form.$('channelType').value.label === channelType.overstockCA && (
						<OverstockCAChannelSettings viewStore={channelEditViewStore} />
					)}
					{form.$('channelType').value != '' &&
						(form.$('channelType').value.label === channelType.buybuyBaby ||
							form.$('channelType').value.label === channelType.mattressFirm ||
							form.$('channelType').value.label === channelType.homeDepot ||
							form.$('channelType').value.label === channelType.overstock ||
							form.$('channelType').value.label === channelType.wayfair) && (
							<LogicbrokerChannelSettings viewStore={channelEditViewStore} />
						)}

					{form.$('channelType').value != '' && form.$('channelType').value.label === channelType.mirakl && (
						<MiraklChannelSettings viewStore={channelEditViewStore} />
					)}

					{form.$('channelType').value != '' && form.$('channelType').value.label === channelType.shopify && (
						<ShopifyChannelSettings viewStore={channelEditViewStore} />
					)}
					{form.$('channelType').value != '' && form.$('channelType').value.label === channelType.sellerCloud && (
						<SellerCloudChannelSettings viewStore={channelEditViewStore} />
					)}

					<div className="container__group">
						<div className="spc--bottom--sml">
							<BaasicCheckbox
								id={form.$('shouldAcknowledgeOrders').id}
								onChange={event => onCheck(event, form.$('shouldAcknowledgeOrders').path)}
								label="CHANNEL.SHOULDACKNOWLEDGE"
								checked={form.$('shouldAcknowledgeOrders').value}
							/>
						</div>

						{form.$('channelType').value != '' &&
							(form.$('channelType').value.label === channelType.amazon ||
								form.$('channelType').value.label === channelType.walmart) && (
								<div className="spc--bottom--sml">
									<BaasicCheckbox
										id={form.$('shouldAutoCancel').id}
										onChange={event => onCheck(event, form.$('shouldAutoCancel').path)}
										label="CHANNEL.SHOULDAUTOCANCEL"
										checked={form.$('shouldAutoCancel').value}
									/>
								</div>
							)}

						{form.$('channelType').value != '' && form.$('channelType').value.label === channelType.amazon && (
							<div className="spc--bottom--sml">
								<BaasicCheckbox
									id={form.$('checkBuyShippingSunday').id}
									onChange={event => onCheck(event, form.$('checkBuyShippingSunday').path)}
									label="CHANNEL.CHECKBUYSHIPPINGSUNDAY"
									checked={form.$('checkBuyShippingSunday').value}
								/>
							</div>
						)}
					</div>
				</div>
				<div className="container__footer type--right">
					<button className="btn btn--med btn--success spc--bottom--sml" type="submit" disabled={loading}>
						{loading ? (
							<div className="spinnercont spc--right--sml">
								<div className="spinner"></div>
							</div>
						) : null}
						{t('SAVE')}
					</button>
				</div>
			</form>
			<BaasicModal modalParams={channelEditViewStore.editRestockDateModal}>
				<RestockDate parentViewStore={channelEditViewStore} />
			</BaasicModal>
			<BaasicModal modalParams={channelEditViewStore.editChannelWarehouseCodesModal}>
				<WarehouseCodes parentViewStore={channelEditViewStore} />
			</BaasicModal>
			<BaasicModal className="ReactModal--lrg" modalParams={channelEditViewStore.updateInventoryLogModal}>
				<UpdateInventoryLog parentViewStore={channelEditViewStore} />
			</BaasicModal>
			<BaasicModal className="ReactModal--lrg-inter" modalParams={channelEditViewStore.customLabelModal}>
				<CustomLabel parentViewStore={channelEditViewStore} />
			</BaasicModal>
		</section>
	);
};

const SellerCloudChannelSettings = observer(({ viewStore }) => {
	const { form, onSelectChange, sellerCloudChannelsOptions } = viewStore;
	return (
		<div className="container__group">
			<div className="row">
				<div className="col col-sml-12 col-lrg-6">
					<BaasicInput field={form.$('serverId')} />
				</div>
				<div className="col col-sml-12 col-lrg-6">
					<BaasicInput field={form.$('userName')} />
				</div>
				<div className="col col-sml-12 col-lrg-6">
					<BaasicInput field={form.$('password')} />
				</div>
				<div className="col col-sml-12 col-lrg-6">
					<BaasicSelect
						field={form.$('channelId')}
						value={form.$('channelId').value}
						options={sellerCloudChannels}
						onChange={value => onSelectChange(value, form.$('channelId'), false)}
					/>
				</div>
			</div>
		</div>
	);
});

const MiraklChannelSettings = ({ viewStore }) => {
	const { form } = viewStore;
	return (
		<div className="container__group">
			<div className="row">
				<div className="col col-sml-12 col-lrg-6">
					<BaasicInput field={form.$('url')} />
				</div>
				<div className="col col-sml-12 col-lrg-6">
					<BaasicInput field={form.$('apiKey')} />
				</div>
				<div className="col col-sml-12 col-lrg-6">
					<BaasicInput field={form.$('shopId')} />
				</div>
			</div>
		</div>
	);
};

const GeneralChannelSettings = observer(({ viewStore, t }) => {
	const {
		channelTypeOptions,
		channelTypeDisabled,
		onSelectChange,
		loadingCarriers,
		channelCarriers,
		selectedCarriers,
		onCarrierChange,
		onMenuClose,
		timezoneOptions,
		handleOnTimezoneMenuScroll,
		debouncedTimezoneSearch,
		isTimezoneLoading,
		form,
		sellerDropdownStore,
		isSuperAdmin,
		isEdit,
	} = viewStore;
	return (
		<div className="container__group">
			<div className="row">
				<div className="col col-sml-12 col-lrg-6 spc--bottom--sml">
					{isSuperAdmin && (
						<BaasicDropdown
							dropdownStore={sellerDropdownStore}
							placeholder={t('PLACEHOLDER.SELLER')}
							className="w--200--px spc--right--sml"
							isDisabled={isEdit}
						/>
					)}
				</div>
			</div>
			<div className="row">
				<div className="col col-sml-12 col-lrg-6">
					<BaasicInput autoFocus field={form.$('name')} />
				</div>
				<div className="col col-sml-12 col-lrg-6 spc--bottom--sml">
					<BaasicSelect
						field={form.$('channelType')}
						clearable={false}
						options={channelTypeOptions}
						value={form.$('channelType').value}
						onChange={value => onSelectChange(value, form.$('channelType'), true)}
						isDisabled={channelTypeDisabled}
					/>
				</div>
				<div className="col col-sml-12 col-lrg-6 spc--bottom--sml">
					<BaasicSelect
						field={form.$('timezone')}
						options={timezoneOptions.slice()}
						value={form.$('timezone').value}
						onChange={value => onSelectChange(value, form.$('timezone'), false)}
						onMenuScrollToBottom={handleOnTimezoneMenuScroll}
						onInputChange={debouncedTimezoneSearch}
						onMenuClose={onMenuClose}
						isLoading={isTimezoneLoading}
					/>
				</div>
				{form.$('channelType').value != '' && form.$('channelType').value.label !== channelType.amazonVendor && (
					<div className="col col-sml-12 col-lrg-6 spc--bottom--sml">
						<BaasicSelect
							field={form.$('carrierChannels')}
							isMulti={true}
							isLoading={loadingCarriers}
							options={channelCarriers}
							value={selectedCarriers.slice()}
							defaultValue={selectedCarriers.slice()}
							onChange={onCarrierChange}
							validation={true}
						/>
					</div>
				)}
			</div>
		</div>
	);
});

const ShopifyChannelSettings = observer(({ viewStore }) => {
	const { form } = viewStore;
	return (
		<div className="container__group">
			<div className="row">
				<div className="col col-sml-12 col-lrg-6">
					<BaasicInput field={form.$('url')} className="fs-mask" />
				</div>
				<div className="col col-sml-12 col-lrg-6">
					<BaasicInput field={form.$('accessToken')} className="fs-mask" />
				</div>
			</div>
		</div>
	);
});

const OverstockCAChannelSettings = observer(({ viewStore }) => {
	const { form } = viewStore;
	return (
		<div className="container__group">
			<div className="row">
				<div className="col col-sml-12 col-lrg-6">
					<BaasicInput field={form.$('apiKey')} className="fs-mask" />
				</div>
				<div className="col col-sml-12 col-lrg-6">
					<BaasicInput field={form.$('partnerId')} className="fs-mask" />
				</div>
			</div>
		</div>
	);
});

const LogicbrokerChannelSettings = observer(({ viewStore }) => {
	const { form } = viewStore;
	return (
		<div className="container__group">
			<div className="row">
				<div className="col col-sml-12 col-lrg-6">
					<BaasicInput field={form.$('apiKey')} className="fs-mask" />
				</div>
				<div className="col col-sml-12 col-lrg-6">
					<BaasicInput field={form.$('partnerId')} className="fs-mask" />
				</div>
			</div>
		</div>
	);
});

const CostcoChannelSettings = observer(({ viewStore }) => {
	const { form } = viewStore;
	return (
		<div className="container__group">
			<div className="row">
				<div className="col col-sml-12 col-lrg-6">
					<BaasicInput field={form.$('apiKey')} className="fs-mask" />
				</div>
				<div className="col col-sml-12 col-lrg-6">
					<BaasicInput field={form.$('partnerId')} className="fs-mask" />
				</div>
			</div>
		</div>
	);
});

const WooCommerceChannelSettings = observer(({ viewStore }) => {
	const { form } = viewStore;
	return (
		<div className="container__group">
			<div className="row">
				<div className="col col-sml-12 col-lrg-6">
					<BaasicInput field={form.$('url')} />
				</div>
				<div className="col col-sml-12 col-lrg-6">
					<BaasicInput field={form.$('consumerKey')} className="fs-mask" />
				</div>
				<div className="col col-sml-12 col-lrg-6">
					<BaasicInput field={form.$('consumerSecret')} className="fs-mask" />
				</div>
			</div>
		</div>
	);
});

const AmazonVendorChannelSettings = observer(({ viewStore, t }) => {
	const { form, onAuthorizeAmazon, amazonOAuthStateHash, authorizedOAuthConfirmModal, isEdit, onCheck } = viewStore;
	return (
		<React.Fragment>
			<BaasicConfirmModal modalParams={authorizedOAuthConfirmModal} />
			<div className="container__group">
				<h3 className="container__subtitle">{t('CHANNEL.SELLINGPARTNERAPICREDENTIALS')}</h3>
				<div className="row">
					<div className="col col-sml-12 col-lrg-6">
						<BaasicInput field={form.$('amazonSellerId')} className="fs-mask" />
					</div>
					<div className="col col-sml-12 col-lrg-6">
						<BaasicInput field={form.$('marketplaceId')} />
					</div>
					<div className="col col-sml-12 col-lrg-6">
						<BaasicInput field={form.$('refreshToken')} className="fs-mask" />
					</div>
					<div className="col col-sml-12 col-lrg-6">
						<BaasicInput field={form.$('sellingPartyId')} className="fs-mask" />
					</div>
				</div>
				{
					<ButtonAndLink
						label={t('CHANNEL.AUTHORIZEVENDOR')}
						btnClass="btn btn--med btn--primary spc--right--sml spc--bottom--sml"
						url={getAmazonOAuthUrl(true, amazonOAuthStateHash)}
						onClick={() => onAuthorizeAmazon()}
					/>
				}
			</div>

			{process.env.NODE_ENV !== 'production' && (
				<div className="spc--bottom--sml">
					<BaasicCheckbox
						id={form.$('useSandbox').id}
						onChange={event => onCheck(event, form.$('useSandbox').path)}
						label="CHANNEL.USESANDBOX"
						checked={form.$('useSandbox').value}
					/>
				</div>
			)}
		</React.Fragment>
	);
});

const AmazonChannelSettings = observer(({ viewStore, t }) => {
	const {
		form,
		carrierTypes,
		channelCarriers,
		selectedCarriers,
		onSelectChange,
		onAuthorizeAmazon,
		amazonOAuthStateHash,
		authorizedOAuthConfirmModal,
	} = viewStore;
	return (
		<React.Fragment>
			<BaasicConfirmModal modalParams={authorizedOAuthConfirmModal} />
			<div className="container__group">
				<h3 className="container__subtitle">{t('CHANNEL.SELLINGPARTNERAPICREDENTIALS')}</h3>
				<div className="row">
					<div className="col col-sml-12 col-lrg-6">
						<BaasicInput field={form.$('amazonSellerId')} className="fs-mask" />
					</div>
					<div className="col col-sml-12 col-lrg-6">
						<BaasicInput field={form.$('marketplaceId')} />
					</div>
					<div className="col col-sml-12 col-lrg-6">
						<BaasicInput field={form.$('refreshToken')} className="fs-mask" />
					</div>
				</div>

				{
					<ButtonAndLink
						label={t('CHANNEL.AUTHORIZESELLER')}
						btnClass="btn btn--med btn--primary spc--right--sml spc--bottom--med"
						url={getAmazonOAuthUrl(false, amazonOAuthStateHash)}
						onClick={() => onAuthorizeAmazon()}
					/>
				}
				<h3 className="container__subtitle">{t('CHANNEL.BUYSHIPPINGCARRIERS')}</h3>

				{/* Use Buy Shipping toogle/slider */}
				<div className="spc--bottom--sml">
					<SliderCheckBox field={form.$('useBuyShippingForPrime')} />
				</div>
				<div className="spc--bottom--sml">
					<SliderCheckBox field={form.$('useBuyShippingForNonPrime')} />
				</div>

				{/* Buy Shipping carriers */}
				{carrierTypes.map(item => {
					return (
						<React.Fragment id={item.id}>
							<div className="row">
								<div className="col col-sml-12 col-lrg-6 spc--bottom--sml">
									<BaasicSelect
										field={form.$(`${item.abrv.toLowerCase()}BuyShippingCarrier`)}
										options={
											_.filter(channelCarriers, carrier => {
												return carrier.extra.carrierTypeId == item.id && selectedCarriers
												 && _.filter(selectedCarriers, selectedCarrier => 
													{return selectedCarrier.value==carrier.value}).length > 0;
											})
											
										}
										value={form.$(`${item.abrv.toLowerCase()}BuyShippingCarrier`).value}
										defaultValue={form.$(`${item.abrv.toLowerCase()}BuyShippingCarrier`).value}
										onChange={value => onSelectChange(value, form.$(`${item.abrv.toLowerCase()}BuyShippingCarrier`))}
										validation={true}
										isClearable={true}
										disabled={!form.$('useBuyShippingForPrime').value && !form.$('useBuyShippingForNonPrime').value}
									/>
								</div>
							</div>
						</React.Fragment>
					);
				})}

				<h3 className="container__subtitle">{t('CHANNEL.UPDATEINVENTORY')}</h3>
				<div className="spc--bottom--sml">
					<SliderCheckBox field={form.$('useAmazonMli')} />
				</div>
			</div>
		</React.Fragment>
	);
});

const WalmartChannelSettings = observer(({ viewStore }) => {
	const { form } = viewStore;
	return (
		<div className="container__group">
			<div className="row">
				<div className="col col-sml-12 col-lrg-6">
					<BaasicInput field={form.$('apiKey')} className="fs-mask" />
				</div>
				<div className="col col-sml-12 col-lrg-6">
					<BaasicInput field={form.$('apiSecret')} className="fs-mask" />
				</div>
			</div>
		</div>
	);
});

export default defaultTemplate(ChannelEditTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/channel/pages/ChannelEditTemplate.jsx